import '../../App.css';
import { TabContext, TabPanel } from '@mui/lab';
import CarDoorSystemTab from './CarDoorSystemTab';
import CarTractionSystemTab from './CarTractionSystemTab';
import CarAuxiliarySystemTab from './CarAuxiliarySystemTab';
import CarAirConditioningSystemTab from './CarAirConditioningSystemTab';
import CarVccSystemTab from './CarVccSystemTab';

const CarSystemStatusTab = (props) => {
    const { packet, car, systemStatusMenuIndex } = props;

    return (
        <>
            <TabContext value={String(systemStatusMenuIndex)}>
                <TabPanel value={'0'} sx={{ height: '100%' }}>
                    <CarDoorSystemTab packet={packet} />
                </TabPanel>
                <TabPanel value={'1'} sx={{ height: '100%' }}>
                    <CarTractionSystemTab packet={packet} car={car} />
                </TabPanel>
                <TabPanel value={'2'} sx={{ height: '100%' }}>
                    <CarAuxiliarySystemTab packet={packet} car={car} />
                </TabPanel>
                <TabPanel value={'3'} sx={{ height: '100%' }}>
                    <CarAirConditioningSystemTab packet={packet} />
                </TabPanel>
                <TabPanel value={'4'} sx={{ height: '100%' }}>
                    <CarVccSystemTab packet={packet} />
                </TabPanel>
            </TabContext>
        </>
    );
};

export default CarSystemStatusTab;